module.exports = __webpack_public_path__ + "media/images/icon__betPick--pick@2x-5f9eb229ca8d715a1654a7a11086bccc.png";